<template>
  <el-dialog title="新增回款计划" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="110px">
      <el-form-item label="客户名称:" prop="customerId">
        <el-select v-model="data.customerId" placeholder="请选择客户" @change="customerChange" filterable clearable style="width:100%">
          <el-option v-for="dict in customerList" :key="dict.id" :label="dict.customerName" :value="dict.id"/>
        </el-select>
      </el-form-item>
      <el-form-item label="合同名称:" prop="contractId">
        <el-select v-model="data.contractId" placeholder="请选择合同" @change="contractChange" clearable style="width:100%">
          <el-option v-for="dict in contractList" :key="dict.contractId" :label="dict.contractName" :value="dict.contractId"/>
        </el-select>
      </el-form-item>
      <el-form-item label="合同总额:">
        {{ selectContract.contractAmount ? amountFormat(selectContract.contractAmount) + '元' : '' }}
      </el-form-item>
      <el-form-item label="计划期次:">
        {{data.planFundBatch}}
      </el-form-item>
      <el-form-item label="本期比例:">
        <el-input-number
          v-model="planFundRate"
          placeholder="请输入本期比例"
          :min="0"
          :max="100"
          :precision="2"
          :controls="false"
          clearable
          class="crm-input-number-wrap"
          @change="planFundRateChange"
        />
        <span class="el-input__suffix">%</span>
      </el-form-item>
      <el-form-item label="本期金额:" prop="planFundAmount">
        <el-input-number
          v-model="data.planFundAmount"
          placeholder="请输入本期金额"
          :min="0"
          :max="selectContract.contractAmount"
          :precision="2"
          :controls="false"
          clearable
          class="crm-input-number-wrap"
          @change="planFundAmountChange"
        />
        <span class="el-input__suffix">元</span>
      </el-form-item>
      <el-form-item label="计划回款日期:" prop="planFundDate">
        <el-date-picker v-model="data.planFundDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="负责人:" prop="managerId">
        <UserSelect v-model="data.managerId" placeholder="请选择负责人"></UserSelect>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="clearForm">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import { listSimpleAll } from "@/api/crm/customer";
import { listContract } from "@/api/crm/contract";
import { createContractPlanFund, listContractPlanFund } from "@/api/crm/planFund";
import { mapState } from 'vuex'
import {amountFormat} from '@/utils/index';

export default {
  name: "AddPlanFundDialog",
  props: {
  },
  data() {
    return {
      amountFormat,
      visible: false,
      customerList: [],
      contractList: [],
      selectContract: {},
      planFundRate: undefined,
      rules: {
        customerId: [
          {required: true, type: 'number', message: '请选择客户', trigger: 'change'}
        ],
        contractId: [
          {required: true, type: 'number', message: '请选择合同', trigger: 'change'}
        ],
        planFundAmount: [
          {required: true, type:'number', message: '请输入本期金额', trigger: 'blur'}
        ]
      },
      data: {
        customerId: null,
        contractId: null,
        planFundBatch: null,
        planFundAmount: undefined,
        planFundDate: null,
        managerId: null,
      }
    };
  },
  created() {
    listSimpleAll().then(response => {
      this.customerList = response.data;
    });
    this.getDicts("contract_status").then(response => {
      this.statusOptions = response.data;
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect
  },
  watch: {
    visible (val) {
      if (!val) {
        this.contractList = [];
        this.selectContract = {};
        this.planFundRate = undefined;
        this.data = {
          customerId: null,
            contractId: null,
            planFundBatch: null,
            planFundAmount: undefined,
            planFundDate: null,
            managerId: null,
        }
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    clearForm () {
      this.resetForm('addForm')
      this.visible = false
    },
    open () {
      this.data.managerId = this.currentUserId;
      this.visible = true
    },
    customerChange (customerId) {
      this.contractList = [];
      this.data.contractId = null;
      this.selectContract = {};
      this.data.planFundBatch = null;
      this.data.planFundAmount = undefined;
      this.planFundRate = undefined;
      if (customerId) {
        listContract({customerId: customerId}).then(response => {
          this.contractList = response.data || [];
        });
      }
    },
    contractChange (contractId) {
      console.log('contractChange', contractId);
      this.selectContract = {};
      this.data.planFundBatch = null;
      this.data.planFundAmount = undefined;
      this.planFundRate = undefined;
      if (contractId) {
        this.selectContract = this.contractList.find(item => item.contractId === contractId);
        listContractPlanFund({contractId: contractId}).then(response => {
          let planFundList = response.rows || [];
          this.data.planFundBatch = '第' + (planFundList.length + 1) + '期';
        });
      }
    },
    planFundRateChange (currentValue, oldValue) {
      console.log('planFundRateChange', currentValue, oldValue);
      if (this.selectContract.contractAmount) {
        this.data.planFundAmount = this.selectContract.contractAmount * currentValue / 100;
      }
    },
    planFundAmountChange (currentValue, oldValue) {
      console.log('planFundAmountChange', currentValue, oldValue);
      if (this.selectContract.contractAmount) {
        this.planFundRate = currentValue / this.selectContract.contractAmount * 100;
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          createContractPlanFund(this.data).then(response => {
            this.$emit('success')
            this.clearForm()
            loading.close();
            this.msgSuccess("回款计划新增成功");
          }).catch(error => {
            loading.close()
          })
        }
      });
    }
  }
};
</script>
